import { createContext, useContext } from 'react';

export interface UserType {
  name: string;
  email: string;
  tenant: string[];
  sub: string;
}

export interface UserContextTypes {
  user: UserType;
  setCurrentUser: (currentUser: any) => void;
}

const USER_CONTEXT_DEFAULT_VALUE = {
  user: {} as UserType,
  setCurrentUser: () => {},
};

export const UserContext = createContext<UserContextTypes>(USER_CONTEXT_DEFAULT_VALUE);
export const useUserContext = () => useContext(UserContext);
